import React from 'react';
import styled from 'styled-components';
import { Droppable, Draggable } from 'react-beautiful-dnd';

import {
	defaultImageSlot,
	defaultTextSlot,
	defaultPictogramSlot,
} from 'components/Brochure/layoutConfig';
import Icon from 'components/Icon';

const Container = styled.div`
	padding: 40px 0 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const Wrapper = styled.div`
	position: relative;
`;

const Type = styled.div`
	background-color: hsl(212, 72%, 59%);
	box-shadow: 0px 4px 12px -4px #4A90E2,
							0px 4px 1px -1px #2A77D2,
							0px 4px 5px 1px rgba(74,144,226,0.2),
							0px -1px 2px 1px rgba(94,163,244,0.8) inset;
	color: white;
	border-radius: 8px;
	padding: 24px 32px;
	margin-bottom: 20px;
	display: flex;
	align-content: center;
	justify-content: start;

	&:hover,
	&:active {
		background-color: hsl(212, 72%, 63%);
		box-shadow: 0px 4px 12px -4px hsl(212, 72%, 63%),
								0px 4px 1px -1px #2A77D2,
								0px 4px 5px 1px rgba(74,144,226,0.2),
								0px -1px 2px 1px rgba(94,163,244,0.8) inset;
	}
`;

const TypeIcon = styled(Icon)`
	margin-right: 8px;

	svg {
		fill: white;
	}
`;

const contentTypes = [
	{
		type: 'image',
		title: 'Kuva',
		icon: 'photo',
		slot: defaultImageSlot,
	},
	{
		type: 'text',
		title: 'Teksti',
		icon: 'keyboard',
		slot: defaultTextSlot,
	},
	{
		type: 'pictogram',
		title: 'Piktogrammi',
		icon: 'tag',
		slot: defaultPictogramSlot,
	},
];

const ContentType = props => {

	const types = contentTypes.map(type => (
		<Draggable
			key={type.type}
			draggableId={type.type}
		>
			{(provided) => (
				<Type
					key={type.type}
					innerRef={provided.innerRef}
					{...provided.draggableProps}
					{...provided.dragHandleProps}
				>
					<TypeIcon className="icon" icon={type.icon} />
					{type.title}
				</Type>
			)}
		</Draggable>
	));

	return (
		<Container>
			<Label>Sisältöalueet</Label>
			<Droppable droppableId="controls">
				{(provided) => (
					<Wrapper
						innerRef={provided.innerRef}
						{...provided.droppableProps}
					>
						{types}
						{provided.placeholder}
					</Wrapper>
				)}
			</Droppable>
		</Container>
	)
}

ContentType.propTypes = {
}

export default ContentType
